import { render, staticRenderFns } from "./recruiterLayout.vue?vue&type=template&id=1224e4aa&scoped=true"
import script from "./recruiterLayout.vue?vue&type=script&lang=js"
export * from "./recruiterLayout.vue?vue&type=script&lang=js"
import style0 from "./recruiterLayout.vue?vue&type=style&index=0&id=1224e4aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1224e4aa",
  null
  
)

export default component.exports